import { useMediaQuery } from "react-responsive";
import {
  _1200px,
  _1400px,
  _1500px,
  _1600px,
  _1700px,
  _1800px,
  _576px,
  _768px,
  _992px,
} from "../../utils/mediaBreakpoints";

const QuotationCard = ({ quote }) => {
  console.log(quote);

  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1500 = useMediaQuery({ maxWidth: _1500px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  return (
    <div>
      <p
        className="m-0"
        style={{
          color: "#459EFF",
          fontSize: _576 ? "16px" : _768 ? "18px" : _992 ? "20px" : "25px",
          fontWeight: "500",
          lineHeight: "100%",
        }}
      >
        {quote?.children[0]?.text}
      </p>
    </div>
  );
};

export default QuotationCard;
